import * as v from "valibot";

import { rpcContract } from "../rpc";

export const checkHandleRpcContract = rpcContract({
  name: "checkHandle" as const,
  paramsSchema: v.object({
    handle: v.pipe(
      v.string(),
      v.minLength(3, "Handle must be at least 3 characters"),
      v.regex(/^[a-z0-9_\-.]+$/, "Handle can only contain lowercase letters, numbers, underscores, hyphens, and dots"),
    ),
  }),
  resultSchema: v.object({
    available: v.boolean(),
    suggestions: v.optional(v.array(v.string())),
    errorMessage: v.optional(v.string()),
  }),
});

export type CheckHandleParams = v.InferOutput<(typeof checkHandleRpcContract)["paramsSchema"]>;
export type CheckHandleResult = v.InferOutput<(typeof checkHandleRpcContract)["resultSchema"]>;
